import { ClickAwayListener, Stack, Typography } from "@mui/material";
import update from "../../../api/auth/reservations/reservationItems/update";
import { useState } from "react";
import WushTextField from "../../form/WushTextField";
import { useForm } from "react-hook-form";
import { Edit } from "@mui/icons-material";

export default function EditableReservationItemCost({ reservationItem, refreshOrder }) {
  const [ price, setPrice ] = useState(reservationItem.total_price_dollars);
  const [ editingPrice, setEditingPrice ] = useState(false);

  const { register, handleSubmit } = useForm();

  const onSubmit = (values) => {
    update(reservationItem.reservation_id, reservationItem.id, values, () => {
      refreshOrder && refreshOrder();
      setPrice(values.total_price);
      setEditingPrice(false);
    });
  };

  return (
    <Stack>
      {
        editingPrice ? (
          <Stack direction="row">
            <ClickAwayListener onClickAway={handleSubmit(onSubmit)}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <WushTextField
                  formRegistration={register('total_price')}
                  label="Price"
                  defaultValue={price}
                  type="number"
                  onChange={(e) => setPrice(e.target.value)}
                />
              </form>
            </ClickAwayListener>
          </Stack>
        ) :
        (
          <Stack
            onClick={() => setEditingPrice(true)}
            direction="row"
            gap={0.5}
            sx={{
              cursor: 'pointer',

            }}
          >
            <Typography variant="body1">
              ${price}
            </Typography>
            <Edit fontSize="12px" sx={{ my: 'auto' }}/>
          </Stack>
        )
      }
    </Stack>
  );
}